import { TransactionTEnum } from "cs.node.utils/csapi/provisioning";

export const transactionTypeThemes = [
    {type: TransactionTEnum.Ftp, variant: "success"},
    {type: TransactionTEnum.Rest, variant: "primary"},
    {type: TransactionTEnum.Soap, variant: "danger"},
    {type: TransactionTEnum.XmlHttp, variant: "info"},
]

export const defaultTransactionTypeTheme = { type: undefined, variant: "black" }

export const getTransactionTypeTheme = (transactionType?: TransactionTEnum) =>{
    return transactionTypeThemes.find(theme=>theme.type === transactionType) ?? defaultTransactionTypeTheme
}